// # #############################################
// # Title : Sparklines for Your Brand in Simulation Trends
// # Authors : Atul, Shubham
// # Date : 15th October 2019
// # Last Modified : Shubham, October 2019
// # Version : 19.10.03
// # Description : This is the code for the spark line components on the Scenario Dynamics tab
// # ############################################


import React, { Component, Fragment } from "react";
import SparkLines from './SyncSparks';
import CompSparkLines from './CompetitorSpark';
import "../css/DataScienceTabs.css";
import "../css/SyncSparks.css";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

class SparklinesComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { withRespectTo: "yourBrand" }
    }
    handleChange = event => {
        this.setState({ withRespectTo: event.target.value });
    };
    render() {
        const self = this;
        return (
            <Fragment>
                <FormControl component="fieldset" style={{ position: 'sticky', width: '-webkit-fill-available' }} >
                    <RadioGroup
                        aria-label="position"
                        name="position"
                        value={this.state.withRespectTo}
                        onChange={this.handleChange}
                        row
                        style={{
                            background: '#f5f5f5',
                            width: '-webkit-fill-available',
                            justifyContent: 'center',
                            marginBottom: '-3%'

                        }}
                    >

                        <FormControlLabel
                            value="yourBrand"
                            control={<Radio color="primary" />}
                            label="Your Brand"
                            labelPlacement="end"
                        />
                        <FormControlLabel
                            value="competitors"
                            control={<Radio color="primary" />}
                            label="All Brands"
                            labelPlacement="end"
                        />
                    </RadioGroup>
                </FormControl>
                {this.state.withRespectTo === "yourBrand" ?
                    <div className='sparklines' id="sparklines" style={{ paddingTop: "0px" }} key="yourBrandSparklines">
                        <SparkLines
                            subscribe_ns={self.props.subscribe_ns}
                            style={{ width: "27.5vw" }}
                            unsubscribe_ns={self.props.unsubscribe_ns}
                        />
                    </div>
                    :
                    <div className='sparklines' id="compSparklines" key="compSparklines" style={{ paddingTop: "0px" }}>
                        <CompSparkLines
                            subscribe_ns={self.props.subscribe_ns}
                            style={{ width: "27.5vw" }}
                            unsubscribe_ns={self.props.unsubscribe_ns}
                        />
                    </div>
                }
            </Fragment>

        );
    }
}

export default SparklinesComponent;